import React from "react";

export function LargeGrantApplication() {
  return (
    <div className="fqxi-shortcodes-largeGrantApplication"></div>
  );
}
